/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRecommendationActions {
    getFixupPrototypeFunction() { return PolicyRecommendationActions.fixupPrototype; }

    static newInstance(model: Partial<PolicyRecommendationActions>): PolicyRecommendationActions {
        let obj = Object.assign(new PolicyRecommendationActions(), model);
        PolicyRecommendationActions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRecommendationActions>): PolicyRecommendationActions {
        if (!model) return null;
        return PolicyRecommendationActions.newInstance(<PolicyRecommendationActions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRecommendationActions) {
        if (!obj) return;

        models.PolicyRecommendationActions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRecommendationActions): boolean {
        Object.setPrototypeOf(obj, PolicyRecommendationActions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the recommendation action
     */
    name: string;

    /**
     * Description of the recommendation action
     */
    description: string;

    /**
     * T&C of the recommendation action
     */
    terms_and_conditions: string;

    /**
     * Flag to check if pre-execute is required or not
     */
    preexecute_required: boolean;

}
